import { Language } from '@mewa/types';

import { ReactComponent as deIcon } from './de.svg';
import { ReactComponent as frIcon } from './de.svg';
import { ReactComponent as csIcon } from './de.svg';
import { ReactComponent as plIcon } from './de.svg';
import { ReactComponent as itIcon } from './de.svg';
import { ReactComponent as nlIcon } from './de.svg';

export type LanguageWithProtectiveServiceSegment =
  | Language.DE
  | Language.FR
  | Language.IT
  | Language.PL
  | Language.NL
  | Language.CS;

export const protectiveClothingIconByLang: Record<
  LanguageWithProtectiveServiceSegment,
  React.FunctionComponent<React.SVGProps<SVGSVGElement>>
> = {
  [Language.DE]: deIcon,
  [Language.FR]: frIcon,
  [Language.CS]: csIcon,
  [Language.PL]: plIcon,
  [Language.IT]: itIcon,
  [Language.NL]: nlIcon,
};
